import { render, staticRenderFns } from "./newsLetterForm.vue?vue&type=template&id=65dfba13&scoped=true&"
import script from "./newsLetterForm.vue?vue&type=script&lang=js&"
export * from "./newsLetterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfba13",
  null
  
)

export default component.exports